import { createAction } from 'redux-actions'

import { JitsiConnection } from 'lib-jitsi-meet'
import { createApiActions } from '@tabeeb/modules/shared/utils/actions'

export const notifyStartCall = createAction<void>('NOTIFY_START_CALL')
export const onUserReadyForCall = createAction<void>('ON_USER_READY_FOR_CALL')

export const startCall = createAction<void>('START_CALL')
export const endCall = createAction<void>('END_CALL')

export const disconnect = createAction<void>('DISCONNECT')

export const onConnectionEstablished = createAction<void>('ON_CONNECTION_ESTABLISHED')
export const onConnectionFailed = createAction<unknown | undefined>('ON_CONNECTION_FAILED')

export const setRoomId = createAction<number>('SET_ROOM_ID')
export const setPresenter = createAction<number | null>('SET_PRESENTER')
export const setJitsiConnection = createAction<JitsiConnection>('SET_JITSI_CONNECTION')
export const resetJitsiConnection = createAction<void>('RESET_JITSI_CONNECTION')

export const enterRoom = createAction<number>('ENTER_ROOM')
export const initJitsi = createAction<void>('INIT_JITSI')
export const initJitsiConnection = createAction<void>('INIT_JITSI_CONNECTION')
export const bindConnectionEvents = createAction<void>('BIND_CONNECTION_EVENTS')
export const unbindConnectionEvents = createAction<void>('UNBIND_CONNECTION_EVENTS')
export const dispose = createAction<void>('DISPOSE')

export const getJitsiToken = createApiActions<string, { access_token: string }>('GET_JITSI_TOKEN')
